import { render } from "./updateHomeCobre.vue?vue&type=template&id=38cc204c&scoped=true"
import script from "./updateHomeCobre.vue?vue&type=script&lang=js"
export * from "./updateHomeCobre.vue?vue&type=script&lang=js"

import "./updateHomeCobre.vue?vue&type=style&index=0&id=38cc204c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38cc204c"]])

export default __exports__